import { useCallback, useEffect, useRef, useState } from 'react';
import { getLogger } from '@sas/nova-core/logging';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { useOnAvatarUpdate, useUserGroupActualId } from './useOnAvatarUpdate';
import bundle from '../NovaComponents-Avatar-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(bundle);
const logger = getLogger('Avatar');
export const useAvatarA11yInfo = props => {
  const localize = useTextLocalizer();
  const [name, setName] = useState(undefined);
  const actualId = useUserGroupActualId(props.dataProvider, props.userId, props.type);
  const [fetchedTime, setFetchedTime] = useState();
  const fetchCounter = useRef(0);
  const defaultName = actualId === props.userId ? props.userId : null;
  useEffect(() => {
    return () => {
      // Increment the fetchCounter to discard the fetch response after unmounting
      fetchCounter.current += 1;
    };
  }, []);
  const updateName = useCallback(async () => {
    const fetchCount = ++fetchCounter.current;
    try {
      const name = await props.dataProvider.getName(props.userId, props.type);
      if (fetchCounter.current > fetchCount) return;
      setName(name.length > 0 ? name : defaultName);
    } catch (e) {
      if (fetchCounter.current > fetchCount) return;
      setName(null);
      logger.warn(`Failed to fetch the user info for id:${props.userId} and type: ${props.type}. User name not available.`);
    } finally {
      if (fetchCounter.current > fetchCount) return;
      setFetchedTime(Date.now());
    }
  }, [props.dataProvider, defaultName, props.userId, props.type]);
  useOnAvatarUpdate(props.dataProvider, updateName, props.userId, props.type, fetchedTime);
  useEffect(() => {
    updateName();
  }, [updateName]);
  let defaultTooltip = '';
  if (name === undefined) {
    defaultTooltip = localize('loading.avatar.tooltip.label');
  } else if (name === null) {
    defaultTooltip = localize(`unknown.${props.type ?? 'user'}.tooltip.label`);
  } else {
    defaultTooltip = localize(`avatar.${props.type ?? 'user'}.tooltip.label`, {
      name
    });
  }
  const tooltip = props.tooltip === '' ? props.useAsButton // According to a11y guidelines, button should always have a aria-label
  ? defaultTooltip : undefined : props.tooltip ?? defaultTooltip;
  const ariaLabel = props.ariaLabel === '' ? tooltip : props.ariaLabel ?? tooltip ?? defaultTooltip;
  return {
    ariaLabel,
    tooltip,
    name
  };
};
//# sourceMappingURL=useAvatarA11yInfo.js.map